export const validDDDs = [
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '21',
  '22',
  '24',
  '27',
  '28',
  '31',
  '32',
  '33',
  '34',
  '35',
  '37',
  '38',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '51',
  '53',
  '54',
  '55',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '69',
  '71',
  '73',
  '74',
  '75',
  '77',
  '79',
  '81',
  '82',
  '83',
  '84',
  '85',
  '86',
  '87',
  '88',
  '89',
  '91',
  '92',
  '93',
  '94',
  '95',
  '96',
  '97',
  '98',
  '99',
];

export const isCNPJEmpty = (value: string): boolean => {
  // Retorna true se não houver nenhum dígito (campo apagado, sobrou só a máscara)
  return value.replace(/\D/g, '').length === 0;
};

export const isCEPEmpty = (value: string): boolean => {
  // Retorna true se não houver nenhum dígito (campo apagado, sobrou só a máscara)
  return value.replace(/\D/g, '').length === 0;
};

export const isValidCNPJ = (value: string): boolean => {
  // Remove máscara (pontos, barra e hífen)
  const cnpj = value.replace(/[.\-/]/g, '');

  // Deve ter exatamente 14 dígitos
  if (cnpj.length !== 14) return false;

  // Rejeita sequências de dígitos todos iguais (ex: 00000000000000)
  if (/^(\d)\1+$/.test(cnpj)) return false;

  const calcDigit = (base: string, weights: number[]): number => {
    const sum = base.split('').reduce((acc, char, i) => acc + Number(char) * weights[i], 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const digit1 = calcDigit(cnpj.slice(0, 12), weights1);
  const digit2 = calcDigit(cnpj.slice(0, 13), weights2);

  return Number(cnpj[12]) === digit1 && Number(cnpj[13]) === digit2;
};
